<template>
	<div class="view">
		<header class="header">
			<div class="header-content flex-between flex-center">
				<div class="header-left flex-start flex-center">
					<img src="@/assets/images/logo.png" @click="toIndex"/>
					<div class="header-left-search-div">
						<div class="header-left-search flex-start flex-center">
							<el-input placeholder="请输入商品名称" v-model="search" clearable @change="searchInfo">
								<img slot="prefix" class="input-icon" src="@/assets/images/search.png"/>
							</el-input>
							<div class="search-button" @click="searchInfo">搜索</div>
						</div>
						<div class="search-hot flex-start flex-center">
							<div v-for="(item,index) in hotList" @click="searchvalue(item.name)" :key="item.id" v-if="index < 8">{{item.name}}</div>
						</div>
					</div>
				</div>
				
				<div v-if="user == null" class="header-right flex-end flex-center">
					<router-link to="/login">登录</router-link>
					<router-link to="/register">注册</router-link>
				</div>
				<div v-else class="header-right flex-end flex-center">
					<div @click="toUrl('/exportorder')" class="header-right-item flex-start flex-center">
						<div class="header-right-item-icon">
							<img src="@/assets/images/shopping.png"/>
						</div>
						<div>批量下单</div>
					</div>
					<div @click="toUrl('/coupon')" class="header-right-item flex-start flex-center">
						<div class="header-right-item-icon">
							<img src="@/assets/images/coupon.png"/>
						</div>
						<div>领券中心</div>
					</div>
					<div class="header-right-item flex-start flex-center" @click="toUrl('/cart')">
						<div class="header-right-item-icon">
							<img src="@/assets/images/cart.png"/>
							<div v-if="cartNum > 0 && cartNum <= 99">{{cartNum}}</div>
							<div v-if="cartNum > 99">...</div>
						</div>
						<div>我的购物车</div>
					</div>
					<div class="header-right-item flex-start flex-center" @click="toUrl('/centerindex')">
						<div class="header-right-item-icon">
							<img src="@/assets/images/restier/account.png"/>
						</div>
						<div>个人中心</div>
					</div>
					<div class="header-right-item flex-start flex-center" @click="quit">
						<div class="header-right-item-icon">
							<img src="@/assets/images/quit.png"/>
						</div>
						<div>退出</div>
					</div>
				</div>
			</div>
		</header>
		<div class="header-box"></div>
		<router-view/>
		
		<div class="bottom">
			<div class="bottom-content flex-between flex-center">
				<div class="bottom-content-left">
					<div class="bottom-content-left-title">服务热线</div>
					<div class="bottom-content-left-phone">13717951752</div>
					<div class="bottom-content-left-time">周一至周日 8:00-18:00</div>
				</div>
				
				<div class="bottom-content-center flex-center flex-start">
					<div class="bottom-content-center-left">
						<img src="@/assets/images/wechat.jpg"/>
					</div>
					<div class="bottom-content-center-right">
						<div>小程序二维码</div>
						<div>扫码进入圆迈小程序</div>
					</div>
				</div>
				<div class="bottom-center-right">
					<div class="bottom-center-right-top flex-center flex-midden">
						<div v-if="qalist.length > 0" @click="toUrl('/userquestion?id='+qalist[0].id)">帮助中心</div>
						<div v-if="qalist.length > 0" class="bottom-center-right-top-hr"></div>
						<div @click="toUrl('/userrefundlist')">售后服务</div>
						<div class="bottom-center-right-top-hr"></div>
						<router-link to="/agree?id=1" target="_blank">用户协议</router-link>
						<div class="bottom-center-right-top-hr"></div>
						<router-link to="/agree?id=2">隐私条款</router-link to="/agree?id=1">
					</div>
					<div class="bottom-center-right-bottom">CopyRight @图迈商城2015-2025</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {footerList,qaList,hotKeywords} from "@/api/index"
export default {
	data(){
		return {
			search:"",
			list:[],
			qalist:[],
			hotList:[]
		}
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		cartNum() {
			return this.$store.state.cartNum;
		}
	},
	watch: {
		// 直接使用$route来监听路由变化
		'$route.query': function (newQuery, oldQuery) {
			if(this.$route.path == "/search"){
				this.search = newQuery.name || "";
			}else{
				this.search = "";
			}
		}
	},
	mounted() {
		if(this.$store.state.user == null && this.$cookies.get('userToken')){
			this.$store.dispatch('fetchUser');
			this.$store.dispatch('fetchCartNum');
		}
		qaList().then(res=>{
			if(res.code == 1000){
				this.qalist = res.data;
			}else{
				return this.$message.error(res.message);
			}
		})
		hotKeywords().then(res=>{
			if(res.code == 1000){
				this.hotList = res.data;
			}else{
				return this.$message.error(res.message);
			}
		})
		footerList().then(res=>{
			if(res.code == 1000){
				this.list = res.data;
			}else{
				return this.$message.error(res.message);
			}
		})
		if(this.$route.path == "/search"){
			this.search = this.$route.query.name || "";
		}
	},
  methods:{
	  quit(){
			this.$alert('确定要退出吗？', '提示', {
				confirmButtonText: '确定',
				showCancelButton:true,
				callback: action => {
					if(action  == "confirm"){
						this.$cookies.set('userToken', "");
						window.history.go(0);
					}
				}
		  });
	  },
	  toUrl(url){
		  if(this.$store.state.user == null){
			  this.$router.push("/login");
		  }else{
			  this.$router.push(url);
		  }
	  },
	  toThreeUrl(info){
		  if(info.url){
				window.open(info.url);
		  }
	  },
	  toIndex(){
		  this.$router.push("/");
	  },
	  searchInfo(){
		  if(this.search == ""){
			  return this.$message.error("请输入搜索词");
		  }else{
			  this.$router.push("/search?name="+this.search);
		  }
	  },
	  searchvalue(name){
		  this.$router.push("/search?name="+name);
	  }
  }
}
</script>

<style scoped lang="scss">
	
	
	.bottom{
		background: #C0C0C0;
		width: 100%;
		.bottom-content{
			margin: 0 auto;
			width: 1320px; 
			padding: 40px 0px 60px;
			.bottom-center-right{
				.bottom-center-right-top{
					div{
						font-size: 14px;
						font-weight: 500;
						line-height: 24px;
						color: #FFFFFF;
						cursor: pointer;
					}
					a{
						color: #FFFFFF;
					}
					.bottom-center-right-top-hr{
						width: 1px;
						height: 8px;
						background: #fff;
						margin: 0px 32px;
					}
				}
				.bottom-center-right-bottom{
					text-align: center;
					font-size: 12px;
					color: #FFFFFF;
					margin-top: 12px;
				}
			}
			.bottom-content-center{
				.bottom-content-center-left{
					background-color: #fff;
					width: 136px;
					height: 136px;
					margin-right: 22px;
					padding: 5px;
					border-radius: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					img{
						width: 126px;
						height: 126px;
						border-radius: 100%;
					}
				}
				
				.bottom-content-center-right{
					div{
						text-align: center;
						&:first-of-type{
							font-size: 16px;
							font-weight: 500;
							color: #FFFFFF;
						}
						&:last-of-type{
							font-size: 12px;
							color: #FFFFFF;
							margin-top: 20px;
						}
					}
				}
			}
			.bottom-content-left{
				text-align: center;
				.bottom-content-left-title{
					font-size: 16px;
					font-weight: 500;
					line-height: 22px;
					color: #FFFFFF;
				}
				.bottom-content-left-phone{
					font-size: 32px;
					font-weight: bold;
					line-height: 90px;
					color: #FFFFFF;
					margin-top: 8px;
				}
				.bottom-content-left-time{
					font-size: 14px;
					line-height: 22px;
					color: #FFFFFF;
					margin-top: 8px;
				}
			}
		}
	}
	
	.header-right-item{
		margin-left: 20px;
		font-size: 14px;
		color: #070B13;
		cursor: pointer;
		.header-right-item-icon{
			width: 20px;
			height: 20px;
			flex: 0 0 20px;
			margin-right: 4px;
			position: relative;
			img{
				width: 20px;
				height: 20px;
			}
			div{
				min-width: 12px;
				height: 12px;
				background: #E91A12;
				font-size: 10px;
				font-weight: 500;
				line-height: 12px;
				color: #FFFFFF;
				text-align: center;
				border-radius: 6px;
				position: absolute;
				top: -3px;
				right: -12px;
				transform: translate(-50%, 0%);
				padding: 0px 2px;
			}
		}
	}
	::v-deep .el-input__prefix{
		line-height:40px;
		left: 16px;
	}
	
	::v-deep .el-input__inner{
		border-radius: 0px;
		outline: none;
	}
	::v-deep .el-input--prefix .el-input__inner{
		padding-left: 40px;
	}
	.header{
		width: 100%;
		height: 96px;
		background: #FFFFFF;
		position: fixed;
		top:0px;
		left: 0px;
		right: 0px;
		z-index: 900;
		.header-content{
			width: 1320px;
			margin: 0 auto; 
			height: 96px;
			// padding: 24px 0px;
			.header-left{
				img{
					width: 244px;
					height: 80px;
					object-fit: cover;
					cursor: pointer;
				}
				.header-left-search-div{
					margin-left: 60px;
					.header-left-search{
						width: 420px;
						margin-top: 10px;
						height: 40px;
						.input-icon{
							width: 16px;
							height: 16px;
						}
						
						.search-button{
							width: 80px;
							height: 40px;
							margin-left: 5px;
							background-color: #E91A12;
							border-radius: 10px;
							font-size: 14px;
							line-height: 40px;
							color: #FFFFFF;
							text-align: center;
							cursor: pointer;
						}
					}
					.search-hot{
						div{
							font-size: 12px;
							line-height: 30px;
							margin-right: 10px;
							color: #7a7a7a;
							cursor: pointer;
							&:hover{
								color: #E91A12;
							}
						}
					}
				}
				
			}
			.header-right{
				a{
					font-size: 14px;
					line-height: 48px;
					color: #070B13;
					margin-left: 10px;
				}
			} 
		}
	}
	.header-box{
		width: 100%;
		height: 96px;
	}
</style>